import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'
import { Line, Button } from '../../components';

import '../../css/common/Button.css';

class Header extends Component {

  render() {
    var style        = this.props.style;
    var title        = this.props.title || '';
    var button_title = this.props.button_title;
    var button_act   = this.props.button_action;
    var icon_class   = this.props.icon || '';
    var icon_color   = this.props.iconColor || '';
    var line         = this.props.line === false ? false : true;

    let second_btn_title   = this.props.second_btn_title || '';
    let second_btn_action  = this.props.second_btn_action;
    let display_first_btn  = button_title ? true : false;
    let display_second_btn = second_btn_title && second_btn_action ? true : false;

    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', height: 44, paddingLeft: 15, paddingRight: 10 }}>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          <span className={'fas ' + icon_class} style={{ fontSize: 15, marginRight: 8, color: icon_color ? icon_color : '#1dc2ff' }}></span>
          <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, marginTop: 2, color: '#575757' }}>{ title }</span>
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          { display_second_btn ? <span className='header-second-button flex-container-row' onClick={ () => { second_btn_action() }} style={{ alignItems: 'center' }}><span className='fas fa-plus-circle' style={{ marginRight: 5 }}></span>{ second_btn_title }</span> : null }
          { display_first_btn  ? <span className='header-button' onClick={ () => { button_act() }}>{ button_title }</span> : null }
        </div>
      </div>
      <Line hide={!line} />
    </div>
  }


}

export default Header
